import Changelog from "../../../../../CHANGELOG.md";
import * as React from 'react';
export default {
  Changelog,
  React
};